import { render, staticRenderFns } from "./SuspensaoProgramacaoUnidade.vue?vue&type=template&id=060d5eb6"
import script from "./SuspensaoProgramacaoUnidade.vue?vue&type=script&lang=js"
export * from "./SuspensaoProgramacaoUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports